import { useTranslation } from "react-i18next";
import WordLogo from "@/assets/icons/BunyanLogo";
import BunyanTextLogo from "@/assets/icons/BunyanTextLogo";
import BunyanTextLogoRTL from "@/assets/icons/BunyanTextLogoRTL";
import BunyanTextLogoDark from "@/assets/icons/BunyanTextLogoDark";
import BunyanTextLogoDarkRTL from "@/assets/icons/BunyanTextLogoDarkRTL";
import { useThemeMode } from "@/contexts/ThemeContext";
import { useStoredTheme } from "@/utils/theme-context";

/**
 * Carried over from the old DashboardLayout, because it is white-label logic
 * rather than chrome: an org can upload its own mark and wordmark per colour
 * mode, and those must win over the Bunyan defaults.
 *
 * The wordmark also has an RTL variant, so the fallback matrix is
 * mode x direction. `crossOrigin="anonymous"` is preserved from the original —
 * org logos are served from a different origin.
 */
export const SidebarLogo = ({ collapsed }: { collapsed: boolean }) => {
  const { mode } = useThemeMode();
  const storedTheme = useStoredTheme();
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  if (collapsed) {
    const mark = storedTheme?.logo?.[mode];
    return mark ? (
      <img
        src={mark}
        alt=""
        crossOrigin="anonymous"
        className="size-8 object-contain"
      />
    ) : (
      <WordLogo height={32} width={40} />
    );
  }

  const wordmark = storedTheme?.wideLogo?.[mode];
  if (wordmark) {
    return (
      <img
        src={wordmark}
        alt=""
        crossOrigin="anonymous"
        className="h-8 w-auto max-w-[150px] object-contain"
      />
    );
  }

  const Wordmark =
    mode === "light"
      ? isRTL
        ? BunyanTextLogoRTL
        : BunyanTextLogo
      : isRTL
        ? BunyanTextLogoDarkRTL
        : BunyanTextLogoDark;

  return <Wordmark height={32} width={150} />;
};
